import script from "./bigDataScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./bigDataScreen.vue?vue&type=script&setup=true&lang=js"

import "./bigDataScreen.vue?vue&type=style&index=0&id=7caab3d1&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7caab3d1"]])

export default __exports__